module.exports = __webpack_public_path__ + "img/personal-items.30957bca.png";